import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from '@mui/material';
import { PropTypes } from 'prop-types';

const YesNoDialog = ({ open, onErrorDialogClose, onYes, title, message }) => {
  return (
    <Dialog open={open} onErrorDialogClose={onErrorDialogClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onYes} color="primary">
          Yes
        </Button>
        <Button onClick={onErrorDialogClose} color="primary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
};

YesNoDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onErrorDialogClose: PropTypes.func.isRequired,
  onYes: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
};

export default YesNoDialog;
